import { render, staticRenderFns } from "./BitacoraTabs.vue?vue&type=template&id=2baac4d5"
import script from "./BitacoraTabs.vue?vue&type=script&lang=js"
export * from "./BitacoraTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports